import { render, staticRenderFns } from "./blockTitle2.vue?vue&type=template&id=a2ce0976&scoped=true"
import script from "./blockTitle2.vue?vue&type=script&lang=js"
export * from "./blockTitle2.vue?vue&type=script&lang=js"
import style0 from "./blockTitle2.vue?vue&type=style&index=0&id=a2ce0976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ce0976",
  null
  
)

export default component.exports